import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  to?: string;
}

interface PageHeaderProps {
  title: string;
  description: string;
  eyebrow: string;
  breadcrumbs: BreadcrumbItem[];
  icon?: string;
}

export default function PageHeader({ title, description, eyebrow, breadcrumbs, icon }: PageHeaderProps) {
  return (
    <section className="border-b border-background-200 bg-background-100 pb-10 pt-24 md:pt-28">
      <div className="container-site">
        <nav aria-label="面包屑" className="flex items-center gap-1.5 text-sm text-foreground-600">
          {breadcrumbs.map((b, idx) => (
            <span key={b.label} className="flex items-center gap-1.5">
              {idx > 0 && <i className="ri-arrow-right-s-line" />}
              {b.to ? (
                <Link to={b.to} className="hover:text-primary-700 cursor-pointer">
                  {b.label}
                </Link>
              ) : (
                <span className="text-foreground-900">{b.label}</span>
              )}
            </span>
          ))}
        </nav>

        <div className="mt-6 flex items-center gap-4">
          {icon && (
            <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-primary-500 text-background-50">
              <i className={`${icon} text-2xl`} />
            </span>
          )}
          <div>
            <span className="inline-block rounded-full bg-accent-100 px-4 py-1 text-sm font-medium text-accent-900">
              {eyebrow}
            </span>
            <h1 className="mt-3 font-heading text-2xl md:text-4xl">{title}</h1>
          </div>
        </div>
        <p className="mt-5 max-w-3xl text-sm leading-7 text-foreground-700 md:text-base md:leading-8">
          {description}
        </p>
      </div>
    </section>
  );
}